import * as React from 'react';
import get from 'lodash/get';
import { FLOW_STATIC_METRICS_DISPLAY } from '@utils/flow/meta';
import MetricTrend from './MetricTrend';
import * as Styled from '../styled';
import type { FlowTimeseriesDataResponse } from '../hooks';

export interface FlowEngagementProps {
  data: FlowTimeseriesDataResponse;
}

const FlowEngagement = ({ data }: FlowEngagementProps) => {
  return (
    <Styled.FlowSection $direction="row">
      <Styled.VerticalMetricContainer>
        <MetricTrend
          metricKey="AppTotalEvents"
          name={FLOW_STATIC_METRICS_DISPLAY.AppTotalEvents.name}
          description={FLOW_STATIC_METRICS_DISPLAY.AppTotalEvents.description}
          data={get(data, ['data', 'AppTotalEvents'], [])}
          total={get(data, ['totals', 'AppTotalEvents'], null)}
        />
      </Styled.VerticalMetricContainer>
      <Styled.VerticalMetricContainer>
        <MetricTrend
          metricKey="AppSubscribers"
          name={FLOW_STATIC_METRICS_DISPLAY.AppSubscribers.name}
          description={FLOW_STATIC_METRICS_DISPLAY.AppSubscribers.description}
          data={get(data, ['data', 'AppSubscribers'], [])}
          total={get(data, ['totals', 'AppSubscribers'], null)}
        />
      </Styled.VerticalMetricContainer>
    </Styled.FlowSection>
  );
};

export default React.memo(FlowEngagement);
